import React, { ReactElement, useEffect } from "react";

import { TableDataType } from "../page/Home";
import CustomTable from "./CustomTable";
import SubPlots from "./SubPlots";

interface Props {
  tableData: TableDataType[];
  yValues: string[];
  yValue: string | null;
  failureCriterion: number;
  data: any;
  criterions: {
    key: string;
    value: number;
    set: boolean;
  }[];
  setCriterions: React.Dispatch<
    React.SetStateAction<
      {
        key: string;
        value: number;
        set: boolean;
      }[]
    >
  >;
  failureData: {
    [key: string]: any;
  }[];
  setFailureData: React.Dispatch<
    React.SetStateAction<
      {
        [key: string]: any;
      }[]
    >
  >;
  customFailures: any;
  setCustomFailures: React.Dispatch<any>;
}

export default function Statistics({
  tableData,
  yValue,
  failureCriterion,
  data,
  criterions,
  setCriterions,
  failureData,
  setFailureData,
  customFailures,
  setCustomFailures,
}: Props): ReactElement {
  useEffect(() => {
    setFailureData(Object.values(tableData));
  }, [tableData]);

  useEffect(() => {
    let failures: any = {};
    let tmp = criterions.filter((e) => e.set && e.key && e.value);
    Object.keys(data).forEach((key) => {
      let tmpKey = parseInt(key);
      let zyklus = Number.MAX_SAFE_INTEGER;
      let error: any = null;
      tmp.forEach((e) => {
        if (e.key) {
          let start = data[tmpKey][e.key][0];
          let idx = data[tmpKey][e.key].findIndex(
            (elm: any) => elm > (e.value * start) / 100
          );
          if (idx > -1) {
            if (idx < zyklus) {
              zyklus = idx;
              error = `${e.key} ${e.value}%`;
            }
          }
        }
      });
      if (zyklus < Number.MAX_SAFE_INTEGER) {
        failures[tmpKey] = {
          zyklus: data[tmpKey].ZYKLUS[zyklus],
          error: error,
        };
      }
      setCustomFailures(failures);
    });
  }, [criterions, data]);

  return (
    <div style={{ display: "flex", margin: "10px 10px 0" }}>
      <div style={{ flex: 1, marginRight: "10px" }}>
        <CustomTable
          yValue={yValue}
          failureCriterion={failureCriterion}
          failureData={failureData}
          customFailures={customFailures}
        />
      </div>
      <SubPlots
        failureData={failureData}
        yValue={yValue}
        failureCriterion={failureCriterion}
        customFailures={customFailures}
      />
    </div>
  );
}
